module.exports = __webpack_public_path__ + "media/images/session-aa6bd02aad65b1c09d44f873f6d528b7.png";